export default __webpack_public_path__ + "static/media/ico-generic-db-score-low.afd14e46.svg";